<template>
  <div id="Qrcode" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 fixed-t">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1" :class="!$route.query.install_code ? 'color-primary' : 'color-white'"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">E</span>scanear</div>
        <div class="col-3 t-r f26"></div>
    </div>
    <div class="h4"></div>
    <div class="col-12 pt10 pb10 color-muted">
      <StreamBarcodeReader @decode="onDecode" @loaded="onLoaded" v-if="cam"></StreamBarcodeReader>
    </div>
    <div class="col-12 t-c">
      {{ str  }}
    </div>
    <div class="h5"></div>
  </div>
</template>
<script>
import { StreamBarcodeReader } from "vue-barcode-reader";
export default {
  name: 'Qrcode',
  data () {
    return {
      cam: true,
      str: ''
    }
  },
  created: function () {
    //判断是否支持摄像头
    if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
      this.cam = false;
      alert('No se puede usar la cámara');
    }
    //获取URL参数
    if(this.$route.query.install_code && this.$route.query.install_code.length == 8){
      this.install_code = this.$route.query.install_code;
      this.make_install_password();
    }
  },
  methods: {
    //生成安装密码
    make_install_password() {
      var post_data = {}
      post_data.install_code = this.install_code
      this.post(this.api_url + 'Tec/make_install_password',post_data,true).then((res)=>{
        if(res.status == 1){
          this.password = res.data;
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      })
    },
    //扫码
    onDecode(result) {
      this.$store.commit('setSound','qrcode.mp3');
      this.str = result;
      //判断app_type
      let app_type = this.$store.state.app_type;
      if(app_type == 'Technician'){
        //判断字符开头是否为：install_code:
        if(result.indexOf('install_code:') == 0){
          let install_code = result.replace('install_code:','');
          this.$router.push({path: '/InstallCode',query: {install_code: install_code}});
        }
      }else if(app_type == 'Main'){
        //搜索产品
        let barcode = result;
        let post_data = {}
        post_data.barcode = barcode
        this.post(this.api_url + 'manage/product_barcode_search',post_data).then((res)=>{
          if(res.status == 1){
            this.$router.push({name:'M_Product',query:{from:this.$route.name, id: res.data.product.id}});
          }else{
            this.$store.commit('setAlert',{type:'error',msg: "Error"});
          }
        })
      }
    },
    onLoaded() {
    }
  },
  watch: {
  },
  mounted() {
  },
  beforeDestroy() {
  },
  components: {
    StreamBarcodeReader
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Fun/Qrcode.vue